export function getRoles ({ state, commit }, page = 1) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/roles', { params: { page: page } })
      .then((response) => {
        if (response.data.roles) {
          commit('setRoles', response.data.roles)
        }

        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getAllRoles ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/roles/all')
      .then((response) => {
        if (response.data.roles) {
          commit('setAllRoles', response.data.roles)
        } else {
          if (response && response.data && response.data.message) {
            reject(response.data.message)
          }
        }

        resolve(response.data)
      })
      .catch((error) => {
        if (error.response && error.response.data && error.response.data.message) {
          reject(error.response.data.message)
        } else {
          reject(error)
        }
      })
  })
}

export function getRole ({ state, commit }, roleId) {
  return new Promise((resolve, reject) => {
    if (roleId) {
      axiosInstance.get('/v1/roles/' + roleId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No role id'))
    }
  })
}

export function getCreateRole ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/roles/create')
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function createRole ({ state, commit }, { name, permission }) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/roles', { name, permission })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getEditRole ({ state, commit }, roleId) {
  return new Promise((resolve, reject) => {
    if (roleId) {
      axiosInstance.get('/v1/roles/' + roleId + '/edit')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No role id'))
    }
  })
}

/* eslint-disable-next-line */
export function editRole ({ state, commit }, { id, name, permission }) {
  return new Promise((resolve, reject) => {
    if (id) {
      axiosInstance.patch('/v1/roles/' + id, { name, permission })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No role id'))
    }
  })
}

export function deleteRole ({ state, commit }, roleId) {
  return new Promise((resolve, reject) => {
    if (roleId) {
      axiosInstance.delete('/v1/roles/' + roleId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No role id'))
    }
  })
}
